// extracted by mini-css-extract-plugin
module.exports = {"root":"ab18cce7"};